export enum ScreensLocationScreenByValue {
  ListingLocation = 'Listing',
  CompanyHQ = 'Hq',
}
